<template>
  <div>
    <div class="page-header bordered">
      <h1>Change Password</h1>
    </div>

    <form data-vv-scope="change-password">
      <ShowErrors
        :errorMessages="errorMessages"
      />

      <div class="form-group">
        <label for="password" class="required">Your current password</label>
        <input type="password" v-model="user.password" name="password" class="form-control form-control-lg"
              v-validate="'required'" ref="password" autofocus/>
        <span v-show="errors.has('change-password.password')" class="input-error">
          {{ errors.first('change-password.password') }}
        </span>
      </div>

      <div class="form-group">
        <label for="new_password" class="required">Your new password</label>
        <input type="password" v-model="user.new_password" name="new_password" class="form-control form-control-lg"
              v-validate="'required|min:8'" ref="new_password" />
        <span v-show="errors.has('change-password.new_password')" class="input-error">
          {{ errors.first('change-password.new_password') }}
        </span>
      </div>

      <div class="form-group">
        <label for="confirm_password" class="required">Repeat new password</label>
        <input type="password" v-model="user.confirm_password" name="confirm_password" v-validate="'required|confirmed:new_password'"
              data-vv-as="password" class="form-control form-control-lg" />
        <span v-show="errors.has('change-password.confirm_password')" class="input-error">
          {{ errors.first('change-password.confirm_password') }}
        </span>
      </div>
      <br/>
      <hr>
      <div class="form-group action">
        <button type="button" class="btn btn-lg btn-primary" v-on:click="validate('change-password')">
          Update Password
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ShowErrors from '../common/ShowErrors'

export default {
  components: {
    ShowErrors
  },
  data: function () {
    return {
      user: {
        password: null,
        new_password: null,
        confirm_password: null
      },
      errorMessages: []
    }
  },
  methods: {
    validate (scope) {
      var self = this

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          self.updatePassword()
        }
      })
    },
    updatePassword: function () {
      var self = this

      this.$http.put('/users/' + this.$localStorage.get('user_reference') + '/update_password', { user: this.user })
        .then(function (response) {
          self.errorMessage = ''

          self.$swal({
            title: 'Password updated!',
            type: 'success'
          })
        }).catch(function (error) {
          if (error) {
            var errorMsg = error.response.data.message || error.response.data.error
            self.errorMessages.push(errorMsg)

            self.$swal({
              title: 'Error updating password',
              text: 'Please, check errors in form',
              type: 'error'
            })
          }
        })
    }
  }
}
</script>
